import { formatISOToThaiDate } from 'react-lib/utils/dateUtils';
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Segment } from 'semantic-ui-react';
import "./WalletCreditLabel.scss"

type WalletCreditLabelrops = {
  BillingAndPackageSequence: any;
  BillingCreditWallet: any;
  runSequence: any;
  controller: any;
  setProp: any;
  selectedDivisionId?: string;
}

const WalletCreditLabel = (props: WalletCreditLabelrops) => {

  useEffect(() => {

    if (props.BillingAndPackageSequence?.sequenceIndex === "Action") {
      props.runSequence({ sequence: "BillingAndPackage", action: "GET_CREDIT_WALLET" });
    }

  }, [props.BillingAndPackageSequence?.sequenceIndex, props.selectedDivisionId])


  let updateAt = props.BillingCreditWallet?.balance_updated_at ? formatISOToThaiDate(props.BillingCreditWallet?.balance_updated_at) : ""
  return (
    <div id="WalletCreditLabel">
      {/* Left Section */}
      <div className="credit-balance-left">
        <div className="credit-balance-label">ยอดคงเหลือ</div>
        <div className="credit-balance-timestamp">{updateAt ?? ""}</div>
      </div>

      <div className="credit-balance-amount">
        {props.BillingCreditWallet?.balance
          ? Number(props.BillingCreditWallet.balance).toLocaleString(undefined, { minimumFractionDigits: 2 })
          : "0.00"}
      </div>

      {/* Right Section */}
      <div className="credit-balance-right">

        <div className="credit-balance-text">Credit</div>
      </div>
    </div>
  );
};

export default WalletCreditLabel;

// style={{ width: '190px', height: '60px' }} onClick={() => {
//    props.setProp("BillingAndPackageSequence", {
//      ...props.BillingAndPackageSequence,
//      openTransactionModal: true
//    })
// }